import React from 'react';
import noUserIcon from '../../../../assets/svg/profile.svg';

const NoUsers = () => {
  return (
    <div style={{ textAlign: 'center', marginTop: 100 }}>
      <img src={noUserIcon} alt="سفارشی یافت نشد." height={60} width={60} />
      <div>کاربری یافت نشد.</div>
    </div>
  );
};

export default React.memo(NoUsers);
